import { useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { HiOutlineShieldCheck } from "react-icons/hi2";

import SettingsCard from "./SettingsCard";

import {
  clearMfaSetup,
  startMfaReconfigure,
  verifyMfaReconfigure,
} from "../../../../redux/features/settings/settingsSlice";

import "./MFASettingsCard.css";

export default function MFASettingsCard({ user }) {
  const dispatch = useDispatch();

  const { mfaSetup, isReconfiguringMfa } = useSelector(
    (state) => state.settings,
  );

  const [currentCode, setCurrentCode] = useState("");
  const [newCode, setNewCode] = useState("");

  const handleStart = async (event) => {
    event.preventDefault();

    await dispatch(
      startMfaReconfigure({
        code: currentCode.trim(),
      }),
    ).unwrap();

    setCurrentCode("");
  };

  const handleVerify = async (event) => {
    event.preventDefault();

    await dispatch(
      verifyMfaReconfigure({
        code: newCode.trim(),
      }),
    ).unwrap();

    setNewCode("");
    dispatch(clearMfaSetup());
  };

  return (
    <SettingsCard
      icon={<HiOutlineShieldCheck />}
      title="MFA"
      description="Herconfigureer je authenticator-app."
    >
      {!user?.mfa_enabled && (
        <div className="mfa-card__notice">
          MFA is momenteel niet actief voor dit account.
        </div>
      )}

      {!mfaSetup ? (
        <form className="mfa-card__form" onSubmit={handleStart}>
          <label>Huidige MFA-code</label>

          <input
            value={currentCode}
            onChange={(e) => setCurrentCode(e.target.value)}
            disabled={isReconfiguringMfa}
            placeholder="123456"
            inputMode="numeric"
            autoComplete="one-time-code"
          />

          <button
            disabled={isReconfiguringMfa || currentCode.trim().length < 6}
          >
            {isReconfiguringMfa ? "Starten..." : "Nieuwe MFA configureren"}
          </button>
        </form>
      ) : (
        <div className="mfa-card__setup">
          <div className="mfa-card__qr">
            {mfaSetup.qr_code ? (
              <img src={mfaSetup.qr_code} alt="MFA QR-code" />
            ) : (
              <span>Geen QR-code beschikbaar</span>
            )}
          </div>

          <div className="mfa-card__manual">
            <span>Handmatige code</span>
            <strong>{mfaSetup.manual_code}</strong>
          </div>

          <form className="mfa-card__form" onSubmit={handleVerify}>
            <label>Nieuwe MFA-code</label>

            <input
              value={newCode}
              onChange={(e) => setNewCode(e.target.value)}
              disabled={isReconfiguringMfa}
              placeholder="123456"
              inputMode="numeric"
              autoComplete="one-time-code"
            />

            <button disabled={isReconfiguringMfa || newCode.trim().length < 6}>
              {isReconfiguringMfa ? "Verifiëren..." : "Nieuwe MFA bevestigen"}
            </button>
          </form>
        </div>
      )}
    </SettingsCard>
  );
}
